import $ from 'jquery.js';
import { numberToString, setupLayout, showErrorDialog } from 'common.js';
import { ajaxPost, ajaxGet } from 'network/network-old.js';
import 'bootstrap/js/collapse.js';
import 'jquery-components/bootstrap-datepicker';
import 'jquery-components/bootstrap-validator';
import { fillBootstrapSelectWithAjax, setSelectpickerVal } from 'jquery-components/bootstrap-select';
import { setupImagePreview } from 'jquery-common/image-previews';

// Настройка страницы поиска экскурсий
function setupExcursionSearch() {
    $(function () {
        var availabilityState = {
            excursionId: null,
            requestVersion: 0,
            loadedMonths: {},
            loadingMonths: {},
            availableDatesByMonth: {}
        };

        var pad2 = function (v) {
            return (v < 10 ? "0" : "") + v.toString();
        };

        var toIsoDateLocal = function (date) {
            if (!(date instanceof Date) || isNaN(date.getTime()))
                return null;

            return date.getFullYear().toString()
                + "-" + pad2(date.getMonth() + 1)
                + "-" + pad2(date.getDate());
        };

        var toIsoDateUtc = function (date) {
            if (!(date instanceof Date) || isNaN(date.getTime()))
                return null;

            return date.getUTCFullYear().toString()
                + "-" + pad2(date.getUTCMonth() + 1)
                + "-" + pad2(date.getUTCDate());
        };

        var toIsoDateFromServer = function (value) {
            if (!value)
                return null;

            if (typeof value === "string") {
                var match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
                if (match)
                    return match[1] + "-" + match[2] + "-" + match[3];
            }

            return toIsoDateLocal(new Date(value));
        };

        var refreshDatepickers = function () {
            $("#beginFld, #endFld").each(function (_, elt) {
                var picker = $(elt).data("datepicker");
                if (picker && typeof picker.fill === "function")
                    picker.fill();
                else
                    $(elt).datepicker("update");
            });
        };

        var getViewMonth = function ($input) {
            var picker = $input.data("datepicker");
            if (picker && picker.viewDate instanceof Date && !isNaN(picker.viewDate.getTime()))
                return picker.viewDate.getUTCFullYear().toString() + "-" + pad2(picker.viewDate.getUTCMonth() + 1);

            var dateUtc = $input.datepicker("getUTCDate");
            var iso = toIsoDateUtc(dateUtc);
            if (iso)
                return iso.substr(0, 7);

            var now = new Date();
            return now.getFullYear().toString() + "-" + pad2(now.getMonth() + 1);
        };

        var ensureCurrentSelectionValid = function () {
            if (!availabilityState.excursionId)
                return;

            $("#beginFld, #endFld").each(function (_, elt) {
                var $elt = $(elt);
                var dateUtc = $elt.datepicker("getUTCDate");
                var dateIso = toIsoDateUtc(dateUtc);
                if (!dateIso)
                    return;

                var monthIso = dateIso.substr(0, 7);
                if (!availabilityState.loadedMonths[monthIso])
                    return;

                var monthDates = availabilityState.availableDatesByMonth[monthIso];
                if (!monthDates || !monthDates.has(dateIso))
                    $elt.datepicker("setDate", null);
            });
        };

        var ensureAvailabilityForMonth = function (monthIso) {
            if (!availabilityState.excursionId || !monthIso)
                return;
            if (availabilityState.loadedMonths[monthIso])
                return;
            if (availabilityState.loadingMonths[monthIso] && (Date.now() - availabilityState.loadingMonths[monthIso]) < 15000)
                return;

            availabilityState.loadingMonths[monthIso] = Date.now();
            var excursionId = availabilityState.excursionId;
            var requestVersion = availabilityState.requestVersion;
            ajaxGet(appBase + "Excursion/" + excursionId + "/Availability",
                { month: monthIso + "-01" },
                function (data) {
                    if (requestVersion !== availabilityState.requestVersion || availabilityState.excursionId !== excursionId)
                        return;

                    var monthDates = new Set();
                    if (Array.isArray(data)) {
                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];
                            var dateIso = toIsoDateFromServer(item && item.checkInDate);
                            if (!dateIso || dateIso.substr(0, 7) !== monthIso)
                                continue;
                            monthDates.add(dateIso);
                        }
                    }

                    availabilityState.availableDatesByMonth[monthIso] = monthDates;
                    availabilityState.loadedMonths[monthIso] = true;
                    delete availabilityState.loadingMonths[monthIso];
                    refreshDatepickers();
                    ensureCurrentSelectionValid();
                },
                undefined,
                true);
        };

        var ensureVisibleMonthsLoaded = function () {
            if (!availabilityState.excursionId)
                return;
            ensureAvailabilityForMonth(getViewMonth($("#beginFld")));
            ensureAvailabilityForMonth(getViewMonth($("#endFld")));
        };

        var updateAvailabilityByCurrentExcursion = function () {
            var excursionIdRaw = $("#excursionId").selectpicker("val");
            var excursionId = excursionIdRaw ? parseInt(excursionIdRaw) : null;

            availabilityState.excursionId = excursionId && !isNaN(excursionId) ? excursionId : null;
            availabilityState.requestVersion++;
            availabilityState.loadedMonths = {};
            availabilityState.loadingMonths = {};
            availabilityState.availableDatesByMonth = {};

            refreshDatepickers();
            ensureVisibleMonthsLoaded();
        };

        // Настройка полей выбора даты
        $(".input-daterange").datepicker({
            todayBtn: "linked",
            language: language,
            startDate: minStartDate,
            orientation: "bottom auto",
            todayHighlight: true,
            autoclose: true,
            keepEmptyValues: true,
            beforeShowDay: function (date) {
                if (!availabilityState.excursionId)
                    return true;

                var dateIso = toIsoDateLocal(date);
                if (!dateIso)
                    return true;

                var monthIso = dateIso.substr(0, 7);
                if (!availabilityState.loadedMonths[monthIso]) {
                    ensureAvailabilityForMonth(monthIso);
                    return true;
                }

                var monthDates = availabilityState.availableDatesByMonth[monthIso];
                return monthDates && monthDates.has(dateIso);
            }
        });
        // Установка конца диапазона на следующий день
        $("#beginFld").on("changeDate", function (evt) {
            if (!evt.date || $("#endFld").datepicker("getDate") > evt.date)
                return;
            $("#endFld").datepicker("setDate", evt.date.addDays(1));
        });

        $("#beginFld, #endFld").on("show changeMonth changeYear", function () {
            ensureVisibleMonthsLoaded();
        });

        // Выбор количества детей
        var showHideChildrenAges = function () {
            var childCount = parseInt($(".child-count.selectpicker").selectpicker("val"));
            $(".child").removeClass("dont-show");
            for (var child = childCount + 1; child <= 4; child++)
                $(".child" + child.toString()).addClass("dont-show");
        };
        $(".child-count.selectpicker").on("changed.bs.select", showHideChildrenAges);
        $(".child .selectpicker").on("changed.bs.select", function (e) {
            $(e.target).closest('.child').find('.child-place').prop("checked", $(e.target).selectpicker("val") > 1);
        });
        showHideChildrenAges();

        // Поле страны
        $("#countryId").on("changed.bs.select", function (e) {
            var countryId = $("#countryId").selectpicker("val");
            if (countryId) {
                $("#cityId").prop("disabled", false);
                $("#excursionId").prop("disabled", false);

                var pc = prevCityId;
                fillBootstrapSelectWithAjax("cityId", "Excursion/GetCities", { CountryId: countryId }, prevCityId,
                    function () {
                        var cityId = $("#cityId").selectpicker("val");
                        var excursionId = $("#excursionId").selectpicker("val");
                        $("#cityId").prop("required", (!cityId && !excursionId) || cityId).selectpicker("refresh");
                        $("#excursionId").prop("required", (!cityId && !excursionId) || excursionId).selectpicker("refresh");
                        updateAvailabilityByCurrentExcursion();
                    });
                prevCityId = undefined;
            } else {
                $("#cityId").prop("disabled", true).selectpicker("refresh");
                $("#excursionId").prop("disabled", true).selectpicker("refresh");
                updateAvailabilityByCurrentExcursion();
            }
        });

        var cityChange = function (e) {
            var countryId = $("#countryId").selectpicker("val");
            var cityId = $("#cityId").selectpicker("val");
            if (cityId)
                needValidate = true;

            if (countryId) {// && cityId) {
                var pe = prevExcurId;
                fillBootstrapSelectWithAjax("excursionId", "Excursion/GetExcursions", { CountryId: countryId, CityId: cityId }, prevExcurId,
                    function () {
                        if (!cityId && $("#cityId").prop("required") && $("#cityId")[0].checkValidity())
                            $("#cityId").selectpicker("val", $("#cityId").selectpicker("val"));
                        if (!excursionId && $("#excursionId").prop("required") && $("#excursionId")[0].checkValidity())
                            $("#excursionId").selectpicker("val", $("#excursionId").selectpicker("val"));
                    },
                    function () {
                        var cityId = $("#cityId").selectpicker("val");
                        var excursionId = $("#excursionId").selectpicker("val");
                        $("#cityId").prop("required", (!cityId && !excursionId) || cityId).selectpicker("refresh");
                        $("#excursionId").prop("required", (!cityId && !excursionId) || excursionId).selectpicker("refresh");
                        updateAvailabilityByCurrentExcursion();
                    });
                prevExcurId = undefined;
            }

            if (!countryId)
                updateAvailabilityByCurrentExcursion();
        }

        var excursionChange = function (e) {
            var cityId = $("#cityId").selectpicker("val");
            var excursionId = $("#excursionId").selectpicker("val");
            $("#cityId").prop("required", (!cityId && !excursionId) || cityId).selectpicker("refresh");
            $("#excursionId").prop("required", (!cityId && !excursionId) || excursionId).selectpicker("refresh");

            if (!cityId && $("#cityId").prop("required") && $("#cityId")[0].checkValidity())
                $("#cityId").selectpicker("val", $("#cityId").selectpicker("val"));
            if (!excursionId && $("#excursionId").prop("required") && $("#excursionId")[0].checkValidity())
                $("#excursionId").selectpicker("val", $("#excursionId").selectpicker("val"));
            updateAvailabilityByCurrentExcursion();
            if (needValidate)
                setTimeout(() => $("#excurSearchForm").validator("validate"), 100);
        }

        $("#cityId").on("changed.bs.select", cityChange);
        $("#excursionId").on("changed.bs.select", excursionChange);

        // Страна могла быть выбрана при загрузке страницы, поэтому надо сразу проверить
        if ($("#countryId").val())
            setTimeout(function () { $("#countryId").trigger("changed.bs.select"); }, 500);
        else {
            prevCityId = null;
            prevExcurId = null;
            $("#cityId").prop("disabled", true);
            $("#excursionId").prop("disabled", true);
            updateAvailabilityByCurrentExcursion();
        }

        // Очистка полей
        $("#clrBtn").click(function (evt) {
            evt.preventDefault();
            $(".adult-count").selectpicker("val", 2);
            $(".child-count").selectpicker("val", 0);
            $(".child-count").trigger("changed.bs.select");
            $("#cityId").val(null);
            setSelectpickerVal($("#countryId"), null);
            $("#beginFld").datepicker("setDate", null);
            $("#endFld").datepicker("setDate", null);
            $("input[name='pt'][value='0']").prop("checked", true);
            $(".help-block.with-errors").empty();
            updateAvailabilityByCurrentExcursion();
        });

        $("#excurSearchForm").validator()

        // Пересчет стоимости
        var recalculateSums = function () {
            var blocks = [".excursions-div", ".programs-div"];
            for (var block = 0; block < blocks.length; block++) {
                var sum = 0;
                $(blocks[block] + " tr:not(.dont-show) input[type='checkbox']:checked").each(function (idx, elt) {
                    sum += parseFloat($(elt).closest("tr[data-sum]").attr("data-sum"));
                });
                $(blocks[block] + " .excur-price-summ.total span").text(numberToString(sum, 2));
                $(blocks[block] + " .excur-price-summ.avg span").text(numberToString(sum / totalPersons, 2));
            }
        };
        $("#ExcurForm input[type='checkbox']").change(recalculateSums);

        // Отображение программ только с выбранными экскурсиями
        var showProgramsWithSelectedExcursionsOnly = function () {
            if (!$("#progWithEx").prop("checked")) {
                $(".programs-div tr[data-id].dont-show").removeClass("dont-show");
                recalculateSums();
                return;
            }
            $(".programs-div tr[data-id]").addClass("dont-show");
            var excIds = [];
            $(".excursions-div input[type='checkbox']:checked").closest("tr[data-id]").each(function (idx, elt) {
                excIds.push($(elt).attr("data-id"));
            });
            for (var i = 0; i < excIds.length; i++)
                $(".programs-div p[data-id='" + excIds[i].toString() + "']")
                    .closest("tr[data-id]").removeClass("dont-show");
            recalculateSums();
        };
        $("#progWithEx").change(showProgramsWithSelectedExcursionsOnly);
        $(".excursions-div input[type='checkbox']").change(showProgramsWithSelectedExcursionsOnly);
        showProgramsWithSelectedExcursionsOnly();

        // Добавление в корзину
        $(".add-to-cart").click(function (evt) {
            evt.preventDefault();
            addExcursionsToCart();
        });

        // Просмотр картинок
        setupImagePreview();

        // Просмотр описания экскурсии внутри программы. Используется старый механизм просмотра.
        $(".programs-div a.descr").click(function (evt) {
            evt.preventDefault();
            var $tr = $(this).closest("tr[data-id]");
            var ids = $tr.find("p[data-id]").map(function (idx, elt) {
                return $(elt).attr("data-id");
            }).get();
            var dates = $tr.find("p[data-id]").map(function (idx, elt) {
                var $elt = $(elt);
                allExcursions[$elt.attr("data-id")].date = $elt.attr("data-date");
            });

            var args = [ids, true, null, $(this).text(), undefined, $tr.data('serialized')];

            // XXX: Надеемся что длина урла будет < 2048 chars.
            var historyUri = document.documentURI + "&excp=" + encodeURIComponent(JSON.stringify(args));
            history.pushState({ page: "EXCURSION_PROGRAM", args: args }, "", historyUri);

            showExcursionDescription.apply(this, args);
        });

        window.addEventListener("popstate", function (e) {
            if (!e.state || !e.state.page)
                return;

            if (["EXCURSION", "EXCURSION_PROGRAM"].indexOf(e.state.page) >= 0) {
                showExcursionDescription.apply(null, e.state.args);
                e.preventDefault();
            } else if (e.state.page === "EXCURSION_SEARCH") {
                closeExcursionDescription();
                e.preventDefault();
            }
        });

        // Вызов должен быть в конце.
        loadRequestedPage();
    });
}

function loadRequestedPage() {
    var uri = new URL(document.documentURI);

    try {
        if (uri.searchParams.has("exc")) {
            showExcursionDescription.apply(null, JSON.parse(uri.searchParams.get("exc")));
        } else if (uri.searchParams.has("excp")) {
            showExcursionDescription.apply(null, JSON.parse(uri.searchParams.get("excp")));
        } else {
            // Запрошена страница поиска. Просто обогащаем историю браузера, чтобы
            // хэндлер popstate мог загрузить страницу поиска без перезагрузки.
            history.replaceState({ page: "EXCURSION_SEARCH" }, "");
        }
    } catch (err) {
        console.error("Unable to load requested page", err);
    }
}


// Добавляет выделенные экскурсии и программы в корзину
function addExcursionsToCart() {
    const $excCkBoxes = $(".excursions-div input[type='checkbox']:checked");
    const $excProgramCkBoxes = $(".programs-div input[type='checkbox']:checked");
    if (!$excCkBoxes.length && !$excProgramCkBoxes.length) {
        showErrorDialog(window._LANGUAGE_STRINGS["EXCURSION_ERROR_EMPTY_SELECTION"]);
        return;
    }

    var cartData = {
        searchParamsSerialized: searchParamsSerialized,
        excursionSerialized: $(".excursions-div input[type='checkbox']:checked")
            .closest("tr[data-serialized]").map(function (idx, elt) { return $(elt).attr("data-serialized"); })
            .get().join(),
        excursionProgramSerialized: $(".programs-div input[type='checkbox']:checked")
            .closest("tr[data-serialized]").map(function (idx, elt) { return $(elt).attr("data-serialized"); })
            .get().join(),
    };
    addExcursionToCart(cartData);
}

function addExcursionToCart(cartData, replaceCart) {
    if (replaceCart)
        cartData.replaceCart = true;
    ajaxPost(appBase + "Excursion/AddToCart", cartData, function (data) {
        if (data && data.errorCode && data.errorCode.indexOf('CART_CONFLICT') === 0 && window.showCartConflictModal) {
            var reason = data.errorCode === 'CART_CONFLICT_CURRENCY' ? 'currency' : 'service';
            window.showCartConflictModal({
                reason: reason,
                onReplace: function () { addExcursionToCart(cartData, true); }
            });
            return;
        }
        window.location = appBase + "Cart";
    });
}

// Отображает описание экскурсии
function showExcursionDescription(excursionIds, excursionProgram, date, programName, excursionSerialized, excursionProgramSerialized) {
    var data = { excursionIds: excursionIds, excursionProgram: excursionProgram };
    ajaxGet(appBase + "Excursion/ExcursionDescription", $.param(data, true), function (res) {
        $("#mainPageContent .excur-single").hide();
        $("#mainPageContent").append(res);
        // Копирование элементов - вёрстка достаточно странная, предполагалась как отдельная страница
        // Поэтому чтобы не перезапрашивать у сервера много данных, которые и так есть, они просто копируются
        $(".excursion-description .adult-count").text($(".adult-count.selectpicker").selectpicker("val"));
        $(".excursion-description .child-count").text($(".child-count.selectpicker").selectpicker("val"));
        $(".excursion-description .program-name").text(programName);
        $(".excursion-description input[name='excursionSerialized']").prop("value", excursionSerialized);
        $(".excursion-description input[name='excursionProgramSerialized']").prop("value", excursionProgramSerialized);
        $(".excursion-description input[name='searchParamsSerialized']").prop("value", searchParamsSerialized);
        $("#ExcurDescForm").on("submit", function (e) {
            var cartData = {
                searchParamsSerialized: searchParamsSerialized,
                excursionSerialized: excursionSerialized,
                excursionProgramSerialized: excursionProgramSerialized,
            };
            addExcursionToCart(cartData);
            e.preventDefault();
        });
        if (!data.excursionProgram) $(".excursion-description .excursion-date").text(date);
        for (var i = 0; i < excursionIds.length; i++) {
            var id = excursionIds[i];
            $(".exc-name-" + id.toString()).text(allExcursions[excursionIds[i]].name);
            $(".exc-date-" + id.toString()).text(allExcursions[excursionIds[i]].date);
        }

        // Прокрутка к началу описания
        $("html, body").animate({ scrollTop: $(".search-params").offset().top });
        // Закрытие
        $(".transfer-single .back-to-search, .close-description").click(function (backEvt) {
            backEvt.preventDefault();
            navigateToExcursionSearch();
        });
    });
}

function closeExcursionDescription() {
    $("#mainPageContent .transfer-single").remove();
    $("#mainPageContent .excur-single").show();
}

function navigateToExcursionSearch() {
    var historyUri = new URL(document.documentURI);
    historyUri.searchParams.delete("exc");
    historyUri.searchParams.delete("excp");

    window.history.pushState({ page: "EXCURSION_SEARCH" }, "", historyUri);
    closeExcursionDescription();
}

export {
    setupLayout,
    setupExcursionSearch
}
